<template>
  <div v-if="commentThis" class="comment-item">
    <div class="comment-item-author">
      <el-popover
        popper-class="user-popover"
        placement="bottom-start"
        title=""
        width="210"
        trigger="hover"
        >
          <user-card-new :user="{...commentThis.user, createNum: commentThis.user.createCount}" :avatar-size="40" :inner="true">
          </user-card-new>
        <el-avatar 
          slot="reference" 
          :size="30" 
          :src="commentThis.user.imageAddress || avatarUrl" 
          class="author-avatar"></el-avatar>
      </el-popover>
      <template v-if="commentThis.replyUser">
        <span style="font-size: 14px; "><span class="author-name">{{commentThis.user | getNameStr}}</span> 回复 <span class="author-name">{{commentThis.replyUser | getNameStr}}</span></span>
      </template>
      <template v-else>
        <span class="author-name">{{commentThis.user.name}}</span>
      </template>
    </div>
    <div class="comment-item-content">
      <pre class="comment-item-content-main">{{commentThis.status ? commentThis.content : '（该评论内容被多次举报，已被系统隐藏）'}}</pre>
      <div v-if="commentThis.images" class="comment-item-img">
        <div v-for="img in commentThis.images.split(';').filter(img => img)" :key="img">
          <img v-lazy="img" alt="" @click="handleImage(img)">
        </div>
      </div>
      <div class="comment-item-extra">
        <span>{{ commentThis.createTime | getTimeStr }}</span>
        <span @click="handleLike">
          <svg-icon :icon-class="commentThis.isLike === 1 ? 'cb-qxdz' : 'cb-dz'" :class-name="commentThis.isLike === 1 ? 'icon-cb-qxdz' : 'icon-cb-dz'"></svg-icon>{{ commentThis.likeCount }}
        </span>
        <span @click="handleDislike">
           <svg-icon :icon-class="commentThis.isLike === -1 ? 'cb-qxc' : 'cb-dc'" :class-name="commentThis.isLike === 1 ? 'icon-cb-qxc' : 'icon-cb-dc'"></svg-icon>{{ commentThis.dislikeCount }}
        </span>
        <span @click="showCommentForm = !showCommentForm">回复</span>
        <el-popover
          popper-class="operation-popover"
          placement="bottom"
          title=""
          width="60"
          trigger="click"
          :visible-arrow="false"
          >
            <ul class="operation">
              <li v-if="commentThis.user && userInfo && commentThis.user.id === userInfo.id" @click="handleDelete">删除</li>
              <li v-else @click="handleTipOff">{{commentThis.isReport ? '已举报' : '举报'}}</li>
            </ul>
          <i class="el-icon-more" slot="reference"></i>
        </el-popover>
      </div>
      <publish-comment v-if="showCommentForm" :type="type" :parent-id="commentThis.id" @call-back="handleCommentCallback"></publish-comment>
    </div>
    <tip-off :source-type="4" :source-id="commentThis.id" :show-tip-off-dialog.sync="showTipOffDialog"></tip-off>
    <div v-if="imgDialogShow" class="shadow" >
      <div class="shadow-content">
        <div class="shadow-content-img" v-clickoutside="() => imgDialogShow=false">
          <img :src="imgDialogUrl" ref="imgDetailRef" alt="" @load="checkHeight($event)"/>
          <span @click="() => imgDialogShow=false">×</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import Clickoutside from 'element-ui/src/utils/clickoutside';
import PublishComment from './PublishComment';
import TipOff from '@/components/TipOff';
import UserCardNew from '@/components/UserCardNew';
import { getTimeStr } from '@/utils/utils'
import { commentLike, commentDislike, deleteComment } from '@/api/comment';
export default {
    name: 'CommentItem',
	  inject: ['checkToken'],
	  directives: { Clickoutside },
    components: {
      PublishComment,
      TipOff,
      UserCardNew,
    },
    props: {
        type: { // 评论对象类型
            type: Number,
            required: true,
        },
        comment: { // 评论对象
            type: Object,
            required: true,
        },
    },
    filters: {
      getTimeStr(date) {
        return getTimeStr(date);
      },
      getNameStr(user) {
        return user.name;
      },
    },
    data: () => ({
      avatarUrl: '/static/images/user.png', 
      commentThis: null, 
      showCommentForm: false, // 是否显示回复表单
      showTipOffDialog: false, // 是否显示举报弹窗
      imgDialogShow: false, // 显示大图,
      imgDialogUrl: '', // 大图url 
    }),
    computed: {
      ...mapState('user', ['userInfo']),
    },
    watch: {
      comment: {
        immediate: true,
        handler() {
          this.commentThis = this.comment;
        }
      },
      imgDialogShow(newVal) {
        this.$nextTick(() => {
          this.$refs.imgDetailRef && (this.$refs.imgDetailRef.oncontextmenu = () => !newVal);
        });
      },
    },
    methods: {
      // 放大图片
      handleImage(url) {
          this.imgDialogShow = true;
          const result = url.match(/origin=.+?(\.\w+)&?/);
          if(result){
              url = url.replace(/-thumb.+$/, result[1])
          }
          this.imgDialogUrl = url;
      },
      checkHeight(event) {
        const el = event.currentTarget;

        el.parentNode.parentNode.classList.remove('long');
        if (el.height > (document.body.offsetHeight - 20)) {
            el.parentNode.parentNode.classList.add('long');
        }
      },
      // 点击点赞
      handleLike() {
        if (!this.checkToken()) return ;
        commentLike(this.commentThis.id).then(() => {
          this.$emit('refresh');
        });
      },
      // 点击点踩
      handleDislike() {
        if (!this.checkToken()) return ;
        commentDislike(this.commentThis.id).then(() => {
          this.$emit('refresh');
        });
      },
      // 回复发表回调
      handleCommentCallback() {
        this.showCommentForm = false;
        this.$emit('refresh');
      },
      // 点击举报
      handleTipOff() {
        if (!this.checkToken()) return ;
        if (this.commentThis.isReport) {
          this.$message.warning('已经举报过啦，不能重复举报哦~');
          return ;
        }
        this.showTipOffDialog = true;
      },
      // 点击删除回复
      handleDelete() {
        this.$confirm('确认删除该条回复？').then(() => {
          this.deleteComment();
        });
      },
      // 删除回复
      deleteComment() {
        deleteComment(this.commentThis.id).then(() => {
          this.$message.success('删除成功');
          this.$emit('refresh');
        });
      },
    }
}
</script>

<style lang="scss">
.user-popover {
  padding: 0!important;
}
</style>
<style lang="scss">
.shadow {
	position: fixed;
	top: 0;
	left: 0;
	bottom: 0;
	background: rgba(0, 0, 0, .7);
	z-index: 1994;
	overflow-y:auto;
	width: 100%;
	min-height: 100%;
	
	&-close {
		position: absolute;
		top: 0px;
		color: rgba(255, 255, 255, 0.6);
		font-size: 40px;
		cursor: pointer;
	}

	&-content {
    display: flex;
    margin: 0 auto;
    padding: 10px 0;
    justify-content: center;
    align-items: center;
    width: 85%;
    text-align: center;
    height: 100%;
    &-img {
      position: relative;
      img {
        max-width: 100%;
      }
      > span {
        position: absolute;
        top: -20px;
        right: -30px;
        font-size: 40px;
        cursor: pointer;
        color: rgba(255, 255, 255, 0.6);
      }
    }
    &.long {
      align-items: flex-start;
    }
  }
}
.user-popover {
  padding: 0!important;
  .user {
    padding: 20px 0!important;
  }
  .user-name {
    font-size: 16px;
  }
}
.comment-item {
  color: #999;
  &-author {
    .author-name {
      font-size: 16px;
      color: #333;
    }
    .author-avatar {
      margin-right: 20px;
    }
    &>span {
      vertical-align: middle;
    }
  }
  &-content {
    margin: 0 0 15px 0;
    padding: 0 50px;
    font-size: 14px;
    color: #666;
    &-main {
      padding-bottom: 5px;
      font-family: inherit;
      white-space: break-spaces;
    }
  }
  &-img {
    margin: 15px 0;
    >div {
      position: relative;
      display: inline-block;
      margin-right: 10px;
      border-radius: 4px;
      background-color: #f9f9f9;
      width: 80px;
      height: 80px;
      vertical-align: middle;
      cursor: pointer;
      >img {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        max-width: 100%;
        max-height: 100%;
      }
    }
  }
  &-extra {
    &>span {
      padding-right: 20px;
      cursor: pointer;
      [class*='icon-'] {
        padding-right: 5px;
        font-size: 20px;
        color: rgb(219, 218, 218);
        &.active {
          color: #999;
        }
      }
    }
  }
}
.el-icon-thumb {
  transform: rotateX(180deg);
}
</style>
